import { endpoints } from '@/api/endpoints';
import { getUsersMeResponseSchema } from '@/api/users/schemas';
import { apiRequest } from '@/api/utils/api';

export const getUsersMe = () =>
  apiRequest({ url: endpoints.users.me, method: 'GET', schema: getUsersMeResponseSchema });

export const acknowledgeTermsAndConditions = () =>
  apiRequest({
    url: endpoints.users.me,
    method: 'PATCH',
    schema: getUsersMeResponseSchema,
    data: { isLatestTermsAndConditionsAcknowledged: true },
  });
